
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniaonrentinkharadi() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Kharadi ',
        heading: 'Amruta Travels: Urbania On Rent in Kharadi',
        headingDescription: 'Amruta Travels offers Urbania on Rent in Kharadi, providing a premium and comfortable group travel solution for corporate travel, family outings, airport transfers, school trips, and outstation journeys. Our 13-seater and 17-seater Force Urbania vans come with spacious interiors, air-conditioning, and modern amenities to ensure a smooth and enjoyable ride. With experienced drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels makes Urbania rental in Kharadi convenient, safe, and hassle-free.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "Urbania on rent in Kharadi",
    "description": "Urbania on rent in Kharadi Pune for comfortable and premium group travel. Ideal for corporate travel, family trips, airport transfers, and outstation journeys with fully air-conditioned interiors, cushioned pushback seating, ample luggage space, clean cabins, and professional drivers ensuring a smooth and reliable ride."
  },
  {
    "name": "Force Urbania on rent Kharadi Pune",
    "description": "Force Urbania on rent in Kharadi Pune offering luxury mini bus services for business and leisure travel. Vehicles feature AC interiors, spacious seating, excellent suspension, large luggage capacity, and trained drivers familiar with Kharadi, IT parks, and nearby areas."
  },
  {
    "name": "Urbania rental service Kharadi",
    "description": "Urbania rental service in Kharadi providing reliable transport solutions for corporate offices, families, and tourists. Enjoy AC comfort, plush seating, clean interiors, punctual service, and experienced drivers for local and outstation travel."
  },
  {
    "name": "Urbania van hire in Kharadi",
    "description": "Urbania van hire in Kharadi for small and medium-sized groups. Perfect for airport transfers, meetings, weddings, and tours with air-conditioned interiors, comfortable seating, and professional chauffeurs."
  },
  {
    "name": "Urbania on rent near Kharadi Pune",
    "description": "Urbania on rent near Kharadi Pune with quick availability and doorstep pickup. Suitable for IT professionals, families, and corporate guests, offering AC interiors, spacious seating, and smooth, stress-free travel."
  },
  {
    "name": "13 seater Urbania on rent Kharadi",
    "description": "13 seater Urbania on rent in Kharadi ideal for family trips, airport pickups, and corporate outings. Comes with AC interiors, pushback seating, sufficient luggage space, and experienced drivers."
  },
  {
    "name": "17 seater Urbania on rent Kharadi",
    "description": "17 seater Urbania on rent in Kharadi for larger groups and corporate teams. Luxury AC interiors, spacious seating layout, luggage capacity, and professional drivers ensure premium group travel."
  },
  {
    "name": "Luxury Urbania hire Kharadi",
    "description": "Luxury Urbania hire in Kharadi for premium travel requirements. Designed for executives, weddings, and VIP guests with high-end AC interiors, plush seating, smooth ride quality, and courteous chauffeurs."
  },
  {
    "name": "AC Urbania van hire Kharadi",
    "description": "AC Urbania van hire in Kharadi providing cool, comfortable, and relaxing journeys. Ideal for all seasons with well-maintained air-conditioning, clean interiors, spacious seating, and professional drivers."
  },
  {
    "name": "Force Urbania 17 seater Kharadi",
    "description": "Force Urbania 17 seater in Kharadi for corporate events, family travel, and outstation tours. Offers AC comfort, wide legroom, ample luggage space, and reliable drivers familiar with city and highway routes."
  },
  {
    "name": "Urbania on rent in EON IT Park Kharadi",
    "description": "Urbania on rent in EON IT Park Kharadi for corporate travel, office pickups, and business meetings. Premium AC interiors, comfortable seating, punctual drivers, and professional service tailored for IT professionals."
  },
  {
    "name": "Urbania hire near World Trade Center Kharadi",
    "description": "Urbania hire near World Trade Center Kharadi for executives, corporate teams, and visiting clients. Ensures luxury AC travel with spacious seating, clean interiors, and on-time service."
  },
  {
    "name": "Urbania rental near Magarpatta City",
    "description": "Urbania rental near Magarpatta City for office staff, families, and group travel. AC-equipped vehicles with cushioned seating, luggage space, and experienced drivers ensure comfortable journeys."
  },
  {
    "name": "Urbania Bus hire near Keshav Nagar",
    "description": "Urbania bus hire near Keshav Nagar for family trips, weddings, and corporate outings. Spacious AC interiors, comfortable seating, and professional drivers ensure smooth group transportation."
  },
  {
    "name": "Urbania on rent near Viman Nagar",
    "description": "Urbania on rent near Viman Nagar for airport transfers and city travel. AC luxury interiors, ample luggage space, and drivers experienced with airport routes ensure timely pickups and drops."
  },
  {
    "name": "Urbania on rent Kharadi for corporate travels",
    "description": "Urbania on rent in Kharadi for corporate travels including meetings, conferences, and employee transport. Premium AC interiors, professional chauffeurs, and reliable service meet corporate standards."
  },
  {
    "name": "Urbania hire Kharadi for airport transfer",
    "description": "Urbania hire in Kharadi for airport transfers with punctual pickup and drop service. Spacious AC interiors, luggage-friendly design, and experienced drivers ensure stress-free airport travel."
  },
  {
    "name": "Urbania on rent Kharadi for family trip",
    "description": "Urbania on rent in Kharadi for family trips offering safety, space, and comfort. Ideal for outings and tours with AC interiors, cushioned seating, and professional drivers."
  },
  {
    "name": "Urbania hire Kharadi for Outstation",
    "description": "Urbania hire in Kharadi for outstation travel to Lonavala, Mahabaleshwar, Shirdi, Mumbai, and more. Comfortable AC interiors, smooth ride quality, and experienced drivers ensure relaxed long journeys."
  },
  {
    "name": "Urbania van hire Kharadi for wedding",
    "description": "Urbania van hire in Kharadi for wedding transportation. Perfect for guest and family movement with luxury AC interiors, comfortable seating, and reliable chauffeurs."
  },
  {
    "name": "Book Urbania on rent in Kharadi",
    "description": "Book Urbania on rent in Kharadi easily with flexible booking options. Enjoy luxury AC vehicles, professional drivers, transparent pricing, and dependable service for all travel needs."
  },
  {
    "name": "Online Urbania booking Kharadi",
    "description": "Online Urbania booking in Kharadi for quick and hassle-free reservations. Well-maintained AC vehicles, spacious seating, and trained drivers ensure smooth and timely travel."
  },
  {
    "name": "Urbania cab service Kharadi",
    "description": "Urbania cab service in Kharadi offering premium group transportation. Suitable for corporate, family, airport, and outstation travel with AC comfort and professional drivers."
  },
  {
    "name": "13 Seater Urbania On Rent in Kharadi Pune",
    "description": "13 seater Urbania on rent in Kharadi Pune for families and small groups. AC interiors, comfortable seating, luggage space, and experienced drivers provide a safe and enjoyable journey."
  },
  {
    "name": "Luxury Force Urbania Hire Kharadi",
    "description": "Luxury Force Urbania hire in Kharadi for premium group travel. High-end AC interiors, plush seating, smooth ride quality, and professional chauffeurs deliver a first-class travel experience."
  },
  {
    "name": "Urbania Van Rental Service in Kharadi",
    "description": "Urbania van rental service in Kharadi providing reliable, comfortable, and affordable group travel. AC interiors, spacious seating, luggage capacity, and trained drivers suit corporate, family, and event travel."
  }
],
"tableData": [
  ["Urbania on rent in Kharadi", "Force Urbania on rent Kharadi Pune"],
  ["Urbania rental service Kharadi", "Urbania van hire in Kharadi"],
  ["Urbania on rent near Kharadi Pune", "13 seater Urbania on rent Kharadi"],
  ["17 seater Urbania on rent Kharadi", "Luxury Urbania hire Kharadi"],
  ["AC Urbania van hire Kharadi", "Force Urbania 17 seater Kharadi"],
  ["Urbania on rent in EON IT Park Kharadi", "Urbania hire near World Trade Center Kharadi"],
  ["Urbania rental near Magarpatta City", "Urbania Bus hire near Keshav Nagar"],
  ["Urbania on rent near Viman Nagar", "Urbania on rent Kharadi for corporate travels"],
  ["Urbania hire Kharadi for airport transfer", "Urbania on rent Kharadi for family trip"],
  ["Urbania hire Kharadi for Outstation", "Urbania van hire Kharadi for wedding"],
  ["Book Urbania on rent in Kharadi", "Online Urbania booking Kharadi"],
  ["Urbania cab service Kharadi", "13 Seater Urbania On Rent in Kharadi Pune"],
  ["Luxury Force Urbania Hire Kharadi", "Urbania Van Rental Service in Kharadi"]
],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Urbania On Rent in Kharadi",
    "WhyChoosedescription": "Amruta Travels offers Urbania On Rent in Kharadi, providing a comfortable, stylish, and reliable travel solution for group travel, corporate trips, and family outings."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Family, and Local Travel",
    "WhyChoosedescription": "Whether it’s a corporate meeting, office commute, family trip, or local sightseeing, our Urbania rentals in Kharadi ensure a smooth and comfortable journey."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "Our Urbania vehicles feature plush seating, ample legroom, air conditioning, wide windows, and generous luggage space, making them ideal for short and long-distance travel."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "All Urbania rentals include trained and courteous drivers who ensure punctuality, safety, and a stress-free travel experience across Kharadi and Pune."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Amruta Travels provides transparent and competitive pricing for Urbania rentals in Kharadi, ensuring excellent value for money with no hidden costs."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Vehicles",
    "WhyChoosedescription": "Our Urbania vehicles are regularly serviced and sanitized, maintaining high standards of hygiene, safety, and comfort for every trip."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Route Planning",
    "WhyChoosedescription": "We offer flexible pickup and drop-off locations along with customized routes to suit your travel plan within Kharadi, Pune, or outstation destinations."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking an Urbania On Rent in Kharadi is simple and hassle-free with Amruta Travels. Our support team assists you at every step for a seamless experience."
  }
]

    }

const faqData = [
  {
    question: 'How can I book an Urbania on rent in Kharadi?',
    answer: 'You can book an Urbania on rent in Kharadi by contacting Amruta Travels online, via phone, or by visiting our office. Our team will assist you with the booking process.'
  },
  {
    question: 'Is Urbania suitable for corporate travel from Kharadi?',
    answer: 'Yes, Urbania is ideal for corporate travel, offering spacious seating, air conditioning, and comfort for employees and clients traveling from Kharadi.'
  },
  {
    question: 'Can I rent Urbania in Kharadi for outstation trips?',
    answer: 'Yes, we provide Urbania rentals from Kharadi for both local and outstation travel, ensuring a smooth and comfortable journey.'
  },
  {
    question: 'Does the Urbania rental include a driver?',
    answer: 'Yes, every Urbania rental includes a professional and experienced driver for safe and hassle-free travel.'
  },
  {
    question: 'Are the Urbania vehicles well-maintained?',
    answer: 'Absolutely. All Urbania vehicles are regularly serviced, cleaned, and sanitized to maintain safety, hygiene, and comfort.'
  },
  {
    question: 'What is the cost of Urbania on rent in Kharadi?',
    answer: 'The rental cost depends on distance, duration, and travel type. Contact Amruta Travels for a transparent and customized quote.'
  },
  {
    question: 'Can I customize pickup and drop-off locations in Kharadi?',
    answer: 'Yes, we offer flexible pickup and drop-off options and route customization as per your travel needs.'
  },
  {
    question: 'Why choose Amruta Travels for Urbania rental in Kharadi?',
    answer: 'Amruta Travels offers well-maintained Urbania vehicles, professional drivers, transparent pricing, and reliable support, ensuring a premium travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sandeep More',
    role: 'IT Professional, Kharadi',
    text: 'We rented an Urbania from Kharadi for a corporate trip. The vehicle was clean, comfortable, and the driver was punctual. Great service by Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Ritu Desai',
    role: 'Family Traveler, Kharadi',
    text: 'Booked an Urbania on rent in Kharadi for a family outing. The ride was smooth and comfortable. Highly recommend Amruta Travels!',
    rating: 5
  }
];






















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Kharadi",
  "image": "https://bushireinpune.com/assets/images/urbania-on-rent-kharadi.jpg",
  "description": "Urbania on rent in Kharadi with Amruta Travels. Hire 13 & 17 seater Force Urbania vans for corporate travel, airport transfers, family trips, weddings, outstation journeys, and local sightseeing. Available near EON IT Park, World Trade Center, Magarpatta City, Keshav Nagar, Viman Nagar, and across Kharadi with professional drivers and affordable rates.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2920"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6200",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/urbania-on-rent-kharadi"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Urbania On Rent in Kharadi | Force Urbania Hire | Amruta Travels</title>
  <meta
    name="description"
    content="Urbania on rent in Kharadi with Amruta Travels. Hire 13 & 17 seater Force Urbania vans for corporate travel, airport transfers, family trips, weddings, and outstation journeys at affordable rates."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/110.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniaonrentinkharadi;